// Sidebar backgrounds (Salem 2026-08-27) — pick a club and the left menu wears its kit.
//
// A background is applied by setting <html data-kit="…">; "none" (the plain RepIQ navy) means
// no attribute. The choice is mirrored to localStorage so every reload paints it instantly,
// before React renders — same trick as the theme, so there's no flash of the wrong menu.
//
// Each background is that club's ground on a match night: floodlights and their beams across
// the top, a packed end in club colours filling the middle, the shirt showing through the
// terrace, and the lit pitch running away at the bottom — with the crowd twinkling and a
// floodlight sweep drifting slowly down it.
//
// The artwork is ORIGINAL and drawn in CSS/SVG. No club crest or badge is reproduced — those
// are trademarks and don't belong inside RepIQ. Because it is vector maths rather than a set
// of pictures, it is pin-sharp on any screen at any resolution, fits any menu height exactly,
// and downloads nothing at all. See skins.css for how the scene is assembled.
//
// The 20 clubs are the 2026/27 Premier League season (Coventry, Ipswich and Hull up;
// West Ham, Wolves and Burnley down). Update this list each August.

export const KITS = [
  { id: "none", name: "None", hint: "The plain RepIQ navy" },

  { id: "arsenal", name: "Arsenal", hint: "Red, white sleeves" },
  { id: "aston-villa", name: "Aston Villa", hint: "Claret and sky blue" },
  { id: "bournemouth", name: "Bournemouth", hint: "Cherry red and black" },
  { id: "brentford", name: "Brentford", hint: "Red and white stripes" },
  { id: "brighton", name: "Brighton", hint: "Blue and white stripes" },
  { id: "chelsea", name: "Chelsea", hint: "Royal blue" },
  { id: "coventry", name: "Coventry City", hint: "Sky blue" },
  { id: "crystal-palace", name: "Crystal Palace", hint: "Red and blue, the sash" },
  { id: "everton", name: "Everton", hint: "Royal blue" },
  { id: "fulham", name: "Fulham", hint: "White and black" },
  { id: "hull", name: "Hull City", hint: "Amber and black stripes" },
  { id: "ipswich", name: "Ipswich Town", hint: "Blue and white" },
  { id: "leeds", name: "Leeds United", hint: "Navy, white and yellow" },
  { id: "liverpool", name: "Liverpool", hint: "Deep red, gold trim" },
  { id: "man-city", name: "Manchester City", hint: "Sky blue and navy" },
  { id: "man-united", name: "Manchester United", hint: "Red, black and gold" },
  { id: "newcastle", name: "Newcastle United", hint: "Black and white stripes" },
  { id: "nottingham-forest", name: "Nottingham Forest", hint: "Garibaldi red" },
  { id: "sunderland", name: "Sunderland", hint: "Red and white stripes" },
  { id: "tottenham", name: "Tottenham Hotspur", hint: "Navy and white" },
];

const KEY = "repiq_kit";

export function applyKit(id) {
  const k = id && id !== "none" ? id : "";
  const root = document.documentElement;
  if (k) root.setAttribute("data-kit", k);
  else root.removeAttribute("data-kit");
  try { localStorage.setItem(KEY, id || "none"); } catch { /* ignore */ }
}

export function storedKit() {
  try { return localStorage.getItem(KEY) || "none"; } catch { return "none"; }
}
